export interface PlanningState {
  // Page 2: Scene Dynamic
  dynamicType: 'familial' | 'romantic' | 'transactional' | 'co-working' | '';
  realConversation: string;
  fictionalAnalysis: string;

  // Page 3: Scene Planning
  playerRole: string;
  npcRole: string;
  playerName: string;
  npcName: string;
  npcMotivation: string;
  playerMotivation: string;
  aPlot: string;
  stakes: string;
  locationAtmosphere: string;

  // Step 2.5: B-Plot and Character Nuance
  bPlotSeed: string;
  characterNuanceNotes: string;

  // New B-Plot fields
  bPlotReason:
    | 'intimidate'
    | 'intrigue'
    | 'evade'
    | 'show_value'
    | 'be_understood'
    | 'find_common_ground'
    | 'other'
    | '';
  bPlotReasonOther: string;
  bPlotNature:
    | 'anecdote'
    | 'philosophical_point'
    | 'parable'
    | 'memory'
    | 'personal_revelation'
    | 'option'
    | 'other'
    | '';
  bPlotNatureOther: string;
  bPlotExplanation: string;

  // Extra notes for planning tab
  extraNotes: string;
}

export const initialPlanningState: PlanningState = {
  dynamicType: '',
  realConversation: '',
  fictionalAnalysis: '',
  playerRole: '',
  npcRole: '',
  playerName: '',
  npcName: '',
  npcMotivation: '',
  playerMotivation: '',
  aPlot: '',
  stakes: '',
  locationAtmosphere: '',
  bPlotSeed: '',
  characterNuanceNotes: '',
  bPlotReason: '',
  bPlotReasonOther: '',
  bPlotNature: '',
  bPlotNatureOther: '',
  bPlotExplanation: '',
  extraNotes: '',
};

export const DYNAMIC_TYPE_OPTIONS = [
  {
    value: 'familial',
    label: 'Familial',
    subtitle: 'e.g. brother/sister, mother/child, cousins, and so on.',
  },
  {
    value: 'romantic',
    label: 'Romantic',
    subtitle: 'e.g. wives, husbands, girlfriends, boyfriends, partners, dates',
  },
  {
    value: 'transactional',
    label: 'Transactional',
    subtitle: 'e.g. customer/salesperson, lawyer/client, doctor/patient',
  },
  {
    value: 'co-working',
    label: 'Co-Working',
    subtitle: 'e.g. workers in an office, students at school, and so on.',
  },
] as const;
